"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResponseEventsPath = void 0;
function getResponseEventsPath(uid, dependantUid = false, docId = false) {
    let path = "";
    if (dependantUid !== false)
        path = `user/${uid}/medical_questionnaire_responses`;
    else
        path = `user/${uid}/dependants/${dependantUid}/medical_questionnaire_responses`;
    if (docId !== false)
        path = `${path}/${docId}`;
    return path;
}
exports.getResponseEventsPath = getResponseEventsPath;
